<template>
  <div class="bq-product-ywjk">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <div class="ywjk-desc">
      业务监控平台提供了开箱即用的企业级开放型一站式监控解决方案。包括了IT设施基础监控，外网网络质量拨测监控，基于事件、自定义指标、日志的业务监控。
    </div>
    <div class="container-div">
      <div class="container">
        <div class="left-mark"></div>
        <p>
          业务监控平台服务可用于收集获取服务器资源的监控指标或用户自定义的监控指标，探测服务可用性，以及针对指标设置警报。使您全面了解公司服务器资源使用情况、业务的运行状况和健康度，并及时收到异常报警做出反应，保证应用程序顺畅运行。
        </p>
        <div class="right-mark"></div>
      </div>
      <div class="area">
        <div class="area-title">
          业务监控平台
        </div>
        <div class="area-content">
          <div class="content-item">
            <div class="content-item-title">
              应用层
            </div>
            <div class="content-item-desc">
              <div class="item-title">数据展示</div>
              <div class="item-title">规则配置</div>
              <div class="item-title">应用/服务管理</div>
            </div>
          </div>
          <div class="content-item">
            <div class="content-item-title">
              计算层
            </div>
            <div class="content-item-desc">
              <div class="item-title">FLink</div>
              <div class="item-title">自研计算框架</div>
              <div class="item-title">ODPS</div>
            </div>
          </div>
          <div class="content-item">
            <div class="content-item-title">
              存储层
            </div>
            <div class="content-item-desc">
              <div class="item-title1">ElasticSearch</div>
              <div class="item-title1">MySQL</div>
              <div class="item-title1">Redis</div>
              <div class="item-title1">RocketMQ</div>
            </div>
          </div>
          <div class="content-item">
            <div class="content-item-title">
              主机层
            </div>
            <div class="content-item-desc">
              <div class="item-title1">
                <div class="item-desc-bg">agent</div>
                服务器
              </div>
              <div class="item-title1">
                <div class="item-desc-bg">agent</div>
                服务器
              </div>
              <div class="item-title1">
                <div class="item-desc-bg">agent</div>
                服务器
              </div>
              <div class="item-title1">
                <div class="item-desc-bg">agent</div>
                服务器
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div
      class="bq-advantage"
      v-for="(itemList, idx) in advantageList"
      :key="idx"
    >
      <InfoBox
        :itemObj="item"
        :col="2"
        v-for="item in itemList"
        :key="item.advTitles"
        :classes="'advantage'"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'zsjgl',
  data() {
    return {
      proIntros: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1.Ve4DxD1gK0jSZFsXXbldVXa-72-90.png',
          advTitles: '管理',
          advDesc: '主要管理医疗基础数据及建立规范的数据应用标准',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1N3eVDuL2gK0jSZPhXXahvXXa-86-92.png',
          advTitles: '建立',
          advDesc: '建立一套健康信息化标准体系',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1BHu4DxD1gK0jSZFsXXbldVXa-80-84.png',
          advTitles: '改善',
          advDesc: '从根本上改善和解决医疗系统之间的数据标准问题',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB12RC9DAT2gK0jSZFkXXcIQFXa-86-90.png',
          advTitles: '促进',
          advDesc:
            '确保整个区域或医疗机构数据使用同一套数据标准，促进数据的互认互通',
        },
      ],
      advantageList: [
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1RIKVDND1gK0jSZFsXXbldVXa-92-72.png',
            advTitles: '一站式监控解决方案',
            advDesc:
              '插件自动化插件部署，一站式插件化管理、应用性能监控、系统性能监控。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB17d5UDFY7gK0jSZKzXXaikpXa-88-88.png',
            advTitles: '网络质量拔测监控',
            advDesc:
              '网络质量监控统计，分析、报表和图表展示，实时反应网络质量情况。',
          },
        ],
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1mOuWDHr1gK0jSZFDXXb9yVXa-72-88.png',
            advTitles: '基于事件、自定义指标、日志监控',
            advDesc:
              '自定义基于事件过滤规则、监控指标、日志事件监控，实时处理监控数据。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB19tC3DHj1gK0jSZFuXXcrHpXa-84-84.png',
            advTitles: '数据报表',
            advDesc:
              '监控数据分为图形报表、文档报表，统计分析结果表达等多形式展示数据信息。',
          },
        ],
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
@import './ywjk.less';
</style>
